import type { BalanceKomaRow } from '~/components/balance/KomaTable'
import { KomaTable as BalanceKomaTable } from '~/components/balance/KomaTable'
import type { HatsuDetailKomaData } from '~/pages/BalanceGenerationDetail/models/convertGenerationDetailResponse'

type Props = {
  data: HatsuDetailKomaData[]
  /** 現在コマ (0 = 該当なし)。 当日表示中だけ行をハイライトする (AC-BDH-022)。 */
  currentKoma: number
}

// BalanceGenerationDetail 固有の行 shape (genPlan/genActual、 欠損/補間概念なし) を
// 共通 `~/components/balance/KomaTable` の row 型にマッピングする薄い wrapper。
export const KomaTable = ({ data, currentKoma }: Props): React.ReactElement => {
  const rows: BalanceKomaRow[] = data.map((d) => ({
    koma: d.koma,
    time: d.time,
    plan: d.genPlan,
    actual: d.genActual,
    // 誤差率は backend 算出値 (発電の符号) をそのまま表示する。共通 KomaTable の
    // 再計算式は需要向けの符号なので発電では使わない。
    errorPct: d.genErrorRate,
  }))

  return (
    <BalanceKomaTable
      currentKoma={currentKoma}
      data={rows}
      /* 発電は 0 でない誤差を必ず正負で色分けする。 spec AC-BDH-025 は Ubiquitous で
         「誤差列の色分けをプラス（計画超過）とマイナス（計画未達）で視覚的に区別して
         表示する」 と定めており、 閾値の但し書きが無い。 需要側の 1.5% 閾値をそのまま
         当てると小幅な超過/未達が同じ中立色になり AC に反する (2026-09-03 レビュー指摘)。 */
      errorColorRule="always"
      labelKeyPrefix="page:balanceGenerationDetail.table"
    />
  )
}
